<template>
  <section>
    <el-form inline>
      <el-form-item label="库区编码">
        <el-input
          v-model="filters.keyword"
          placeholder="请输入库区编码"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="库区类型">
        <el-select v-model="filters.AreaType" multiple="">
          <el-option label="高位货架区" value="10"></el-option>
          <el-option label="地堆区" value="20"></el-option>
          <el-option label="不良品区" value="30"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="是否启用">
        <el-select v-model="filters.enabled" multiple="">
          <el-option label="启用" value="0"></el-option>
          <el-option label="禁用" value="1"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>
    <!-- 查询报表 -->
    <el-table-bar :fixed="true" :bottom="35"> 
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        highlight-current-row
        @row-click="handleRowClick"
        v-loading="listLoading"
        @selection-change="selsChange"
          ref="multipleTable"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="areaCode" label="库区编码" sortable>
        </el-table-column>
        <el-table-column prop="areaName" label="库区名称" sortable>
        </el-table-column>
        <el-table-column prop="areaType" label="库区类型" sortable>
          <template slot-scope="scope">{{
            scope.row.areaType == "10"
              ? "高位货架区"
              : scope.row.areaType == "20"
              ? "地堆区"
              : "不良品区"
          }}</template>
        </el-table-column>

        <el-table-column prop="warehouseCode" label="仓库编码" sortable>
        </el-table-column>
        <el-table-column prop="warehouseName" label="仓库名称" sortable>
        </el-table-column>
        <el-table-column prop="status" label="是否启用" sortable>
          <template slot-scope="scope">{{
            scope.row.status ? "禁用" : "启用"
          }}</template>
        </el-table-column>
        <el-table-column label="操作" width="100">
          <template slot-scope="scope">
            <el-button
              @click="getbusinessLoglist(5, scope.row.warehouseAreaId)"
              type="text"
              size="small"
              >日志</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </el-table-bar>
    <div class="block">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total" style="float:right;"
      >
      </el-pagination>
    </div>

    <!-- 新增模块 -->
    <el-dialog
      :visible.sync="addFormVisible"
      v-model="addFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="addForm"
        label-width="80px"
        :rules="addFormRules"
        ref="addRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库区编码"
              prop="AreaCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.AreaCode"
                auto-complete="off"
                placeholder="请输入库区编码"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="库区名称"
              prop="AreaName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="addForm.AreaName"
                auto-complete="off"
                placeholder="请输入库区名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库区类型"
              class="labelcall"
              label-width="120px"
              prop="AreaType"
            >
              <el-select v-model="addForm.AreaType" style="width: 100%">
                <el-option label="高位货架区" value="10"></el-option>
                <el-option label="地堆区" value="20"></el-option>
                <el-option label="不良品区" value="30"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              class="labelcall"
              label-width="120px"
              prop="WarehouseId"
            >
              <el-select v-model="addForm.WarehouseId" filterable style="width: 100%">
                <el-option
                  v-for="item in WareHouse"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select v-model="addForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onAddSubmit" :loading="addLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 修改模块 -->
    <el-dialog
      :visible.sync="editFormVisible"
      v-model="editFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-form
        :model="editForm"
        label-width="80px"
        :rules="editFormRules"
        ref="editRuleForm"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库区编码"
              prop="AreaCode"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.AreaCode"
                auto-complete="off"
                placeholder="请输入库区编码"
                maxlength="30"
                disabled
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="库区名称"
              prop="AreaName"
              class="labelcall"
              label-width="120px"
            >
              <el-input
                v-model="editForm.AreaName"
                auto-complete="off"
                placeholder="请输入库区名称"
                maxlength="50"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="库区类型"
              class="labelcall"
              label-width="120px"
              prop="AreaType"
            >
              <el-select
                v-model="editForm.AreaType"
                :disabled="isVisible"
                style="width: 100%"
              >
                <el-option label="高位货架区" value="10"></el-option>
                <el-option label="地堆区" value="20"></el-option>
                <el-option label="不良品区" value="30"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="仓库名称"
              class="labelcall"
              label-width="120px"
              prop="WarehouseId"
            >
              <el-select
                v-model="editForm.WarehouseId"
                :disabled="isVisible"
                filterable
                style="width: 100%"
              >
                <el-option
                  v-for="item in editWareHouse"
                  :label="item.warehouseName"
                  :value="item.warehouseId"
                  :key="item.warehouseId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item
              label="是否启用"
              class="labelcall"
              label-width="120px"
              prop="Status"
            >
              <el-select v-model="editForm.Status" style="width: 100%">
                <el-option label="启用" value="0"></el-option>
                <el-option label="禁用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" class="row-bg" justify="end">
          <el-button @click="onSubmicancel">取消</el-button>
          <el-button type="primary" @click="onEditSubmit" :loading="editLoading"
            >提交</el-button
          >
        </el-row>
      </el-form>
    </el-dialog>

    <!-- 修改日志 -->
    <el-dialog
      :visible.sync="logFormVisible"
      v-model="logFormVisible"
      :close-on-click-modal="false"
      :hide-required-asterisk="true"
    >
      <el-table
        :data="logtableData"
        height="500"
        border
        style="width: 100%"
        v-loading="loglistLoading"
      >
        <el-table-column prop="createBy" label="操作人" width="120" sortable>
        </el-table-column>
        <el-table-column prop="ip" label="操作人IP地址" width="140" sortable>
        </el-table-column>

        <el-table-column
          prop="createTime"
          label="操作时间"
          width="180"
          sortable
          :formatter="formatdatetime"
        >
        </el-table-column>
        <el-table-column
          prop="description"
          label="操作内容"
          min-width="300"
          sortable
        >
        </el-table-column>
      </el-table>

      <div class="block">
        <el-pagination
          @size-change="loghandleSizeChange"
          @current-change="loghandleCurrentChange"
          :current-page="logpage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="logpageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="logtotal" style="float:right;"
        >
        </el-pagination>
      </div>
    </el-dialog>
  </section>
</template>

<script>
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";
import util from "../../../util/date";
import {
  addWarehouseArea,
  getWarehouseAreaList,
  editWarehouseArea,
  exportWarehouseArea,
  editWarehouseAreaStatus,
  getWarehouseAreabase,
  getWarehouseAreaQueryById,
  getbusinessLog,
} from "../../api/api";
export default {
  components: { Toolbar },
  data() {
    return {
      listLoading: false,
      total: 0,
      page: 1,
      pageSize: 50,
      tableData: [],

      filters: {
        keyword: "",
        enabled: "",
        AreaType: "",
      },
      WareHouse: [],
      buttonList: {},
      addFormVisible: false,
      addLoading: false,
      addForm: {
        AreaCode: "",
        AreaName: "",
        AreaType: "",
        Status: "1",
        WarehouseId: "",
      },
      editWareHouse: [], //修改赋值
      addFormRules: {
        AreaCode: [
          {
            required: true,

            message: "请输入库区编码",
            trigger: "blur",
          },
          {
            message: "库区编码格式不正确,正确格式为字母+数字",
            trigger: "blur",
            pattern: /^((([a-z]|[A-Z])+[0-9]+)|(([A-Z]|[a-z])+[0-9]+))*$/,
          },
        ],
        AreaName: [
          { required: true, message: "请输入库区名称", trigger: "blur" },
        ],
        AreaType: [
          { required: true, message: "请选择库区类型", trigger: "change" },
        ],
        WarehouseId: [
          { required: true, message: "请选择仓库名称", trigger: "change" },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      editFormVisible: false,
      editLoading: false,
      editForm: {
        WarehouseAreaId: 0,
        AreaCode: "",
        AreaName: "",
        AreaType: "",
        Status: "",
        WarehouseId: "",
      },
      editFormRules: {
        AreaCode: [
          {
            required: true,

            message: "请输入库区编码",
            trigger: "blur",
          },
          
        ],
        AreaName: [
          { required: true, message: "请输入库区名称", trigger: "blur" },
        ],

        AreaType: [
          { required: true, message: "请选择库区类型", trigger: "change" },
        ],
        WarehouseId: [
          { required: true, message: "请选择仓库名称", trigger: "change" },
        ],
        Status: [
          { required: true, message: "请选择是否启用", trigger: "change" },
        ],
      },
      currentRow: null,
      sels: [],
      validation: true,
      isVisible: false,
      logFormVisible: false,
      logtableData: [],
      loglistLoading: false,
      logtotal: 0,
      logpage: 1,
      logpageSize: 50,
      logbusinessType: 0,
      logbusinessCode: 0,
      newfilters:{},
    };
  },
  methods: {
    //加载权限按钮
      callFunction(item) {
      if (item.name === "查询") {
         this.page=1;
         this.newfilters =JSON.parse(JSON.stringify(this.filters)) ;
          this.getReportlist.apply(this, item);
      } else {
        this[item.func].apply(this, item);
      }
    },
    //弹出新增框
    onSubmitadd() {
      this.addLoading = false;
      this.addFormVisible = true;
    },
    //弹出修改框
    onSubmitedit() {
      let row = {};
      if (this.sels == null || this.sels.length == 0) {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length > 1) {
        this.$message({
          message: "请选择一行数据,不能多选！",
          type: "error",
        });

        return;
      }
      if (this.sels != null && this.sels.length === 1) {
        row = this.sels[0];
      } else {
        this.$message({
          message: "请选择一行数据！",
          type: "error",
        });

        return;
      }

      this.editLoading = false;
      let ware = JSON.stringify(this.WareHouse);
      if (!row || row.warehouseId == 0) {
        this.$message({
          message: "请选择要编辑的一行数据！",
          type: "error",
        });
        return;
      }
      let pata = {
        id: row.warehouseAreaId,
      };
      this.editWareHouse = [];
      this.editWareHouse = JSON.parse(ware);
      //console.log(this.WareHouse,this.editWareHouse);
      getWarehouseAreaQueryById(pata).then((res) => {
        let editdata = res.data.response;
        if (res.data.success) {
          const index = this.editWareHouse.findIndex(
            (item) => item.warehouseId === editdata.warehouseId
          );

          if (index == -1) {
            let warels = {
              warehouseId: row.warehouseId,
              warehouseName: row.warehouseName,
            };
            this.editWareHouse.push(warels);
          }

          this.editForm.WarehouseAreaId = editdata.warehouseAreaId;
          this.editForm.AreaCode = editdata.areaCode;
          this.editForm.AreaName = editdata.areaName;
          this.editForm.AreaType = editdata.areaType + "";
          this.editForm.Status = editdata.status + "";
          this.editForm.WarehouseId = editdata.warehouseId;
          this.isVisible = editdata.isVisible;
          console.log(this.WareHouse, this.editWareHouse);
          this.editFormVisible = true;
        } else {
          this.$message({
            message: res.data.msg,
            type: "error",
          });
        }
      });
    },

    //隐藏新增修改框
    onSubmicancel() {
      this.addFormVisible = false;
      this.editFormVisible = false;
    },
    //点击行触发，选中或不选中复选框
    handleRowClick(row, column, event) {
      this.flag = !this.flag;
      this.$refs.multipleTable.toggleRowSelection(row, this.flag);
    },
    //获取每页条数
    handleSizeChange(val) {
      this.pageSize = val;
      this.getReportlist();
    },
    //获取页码
    handleCurrentChange(val) {
      this.page = val;
      this.getReportlist();
    },
    //多选
    selsChange(sels) {
      this.sels = sels;
      console.log(sels, 1111);
    },
    //新增
    onAddSubmit() {
      let _this = this;
      this.$refs.addRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              var user = JSON.parse(window.localStorage.user);
              if (!user && user.id == 0) {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect
                    ? _this.$route.query.redirect
                    : "/"
                );
              }
              let para = Object.assign({}, this.addForm);
              console.log(para);
              this.addLoading = true;
              addWarehouseArea(para).then((res) => {
                this.addLoading = false;
                console.log(res);
                if (res.data.success) {
                  this.addFormVisible = false;
                  this.$refs["addRuleForm"].resetFields();
                  this.getReportlist();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },
    //修改
    onEditSubmit() {
      let _this = this;
      this.$refs.editRuleForm.validate((valid) => {
        if (valid) {
          this.$confirm("确认提交吗？", "提示", {})
            .then(() => {
              var user = JSON.parse(window.localStorage.user);
              if (!user && user.id == 0) {
                this.$message({
                  message: "用户信息为空，先登录",
                  type: "error",
                });
                _this.$router.replace(
                  _this.$route.query.redirect
                    ? _this.$route.query.redirect
                    : "/"
                );
              }
              let para = Object.assign({}, this.editForm);
              console.log(para, user);
              this.editLoading = true;
              editWarehouseArea(para).then((res) => {
                this.editLoading = false;
                console.log(res);
                if (res.data.success) {
                  this.editFormVisible = false;
                  this.$refs["editRuleForm"].resetFields();
                  this.getReportlist();
                  this.$message({
                    message: res.data.msg,
                    type: "success",
                  });
                } else {
                  this.$message({
                    message: res.data.msg,
                    type: "error",
                  });
                }
              });
            })
            .catch((err) => {
              console.log(err);
            });
        }
      });
    },

    //查询
    getReportlist() {
      
      let pata = {
        page: this.page,
        pageSize: this.pageSize,
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        areatype: this.newfilters.AreaType.toString(),
      };
      this.listLoading = true;
      getWarehouseAreaList(pata).then((res) => {
        console.log(res);
        this.tableData = res.data.response.pageData;
        this.total = res.data.response.total;
        this.listLoading = false;
      });
    },
    //导出
    handleExport() {
      let row = this.sels;
      let warelist = "";
      row.forEach((item) => {
        warelist += item.warehouseAreaId + ",";
      });
      let pata = {
        key: this.newfilters.keyword,
        enabled: this.newfilters.enabled.toString(),
        areatype: this.newfilters.AreaType.toString(),
        warehouseareaid: warelist.slice(0, warelist.length - 1),
      };
      const loading = this.$loading({
        lock: true,
        text: "导出中，请稍等",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.5)",
      });

      exportWarehouseArea(pata);
      loading.close();
    },
    //点击启用按钮
    handleEnable() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择要启用的一行数据！",
          type: "error",
        });

        return;
      }
      if (row.length == 1) {
        if (row[0].status == 0) {
          this.validation = false;
          this.$message({
            message: "当前数据为启用状态，无需启用！",
            type: "error",
          });
          return;
        }
      }

      row.forEach((item) => {
        if (item.status == 0) {
          this.validation = false;
          this.$message({
            message: "请选择禁用的数据启用！",
            type: "error",
          });

          return false;
        }
      });

      let para = Object.assign([], row);

      console.log(para);
      if (this.validation) {
        this.$confirm("确认启用吗?", "提示", {})
          .then(() => {
            for (let i = 0; i < para.length; i++) {
              para[i].Status = 0;
            }
            editWarehouseAreaStatus(para).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getReportlist();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    //点击禁用按钮
    handleStop() {
      let row = this.sels;
      this.validation = true;
      if (row.length == 0) {
        this.validation = false;
        this.$message({
          message: "请选择启用的数据禁用！",
          type: "error",
        });

        return false;
      }
      if (row.length == 1) {
        if (row[0].status == 1) {
          this.validation = false;
          this.$message({
            message: "当前数据为禁用状态，无需禁用！！",
            type: "error",
          });
          return;
        }
      }
      row.forEach((item) => {
        if (item.status == 1) {
          this.validation = false;
          this.$message({
            message: "请选择启用的数据禁用！",
            type: "error",
          });
          return false;
        }
      });
      if (this.validation) {
        let para = Object.assign([], row);
        this.$confirm("确认禁用吗?", "提示", {})
          .then(() => {
            for (let i = 0; i < para.length; i++) {
              para[i].Status = 1;
            }
            editWarehouseAreaStatus(para).then((res) => {
              if (res.data.success) {
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
                this.getReportlist();
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
            });
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },

    //加载基础资料
    getBasicdatalist() {
      getWarehouseAreabase("").then((res) => {
        console.log(res);
        this.WareHouse = res.data.response.wareHouse;
      });
    },

    //获取每页条数
    loghandleSizeChange(val) {
      this.logpageSize = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //获取页码
    loghandleCurrentChange(val) {
      this.logpage = val;
      this.getbusinessLoglist(this.logbusinessType, this.businessCode);
    },
    //查询
    getbusinessLoglist(businessType, businessCode) {
      this.logbusinessType = businessType;
      this.businessCode = businessCode;
      this.logFormVisible = true;
      let pata = {
        businessType: this.logbusinessType,
        businessCode: this.businessCode,
        page: this.logpage,
        pageSize: this.logpageSize,
      };
      this.loglistLoading = true;
      getbusinessLog(pata).then((res) => {
        console.log(res);
        this.logtableData = res.data.response.pageData;
        this.logtotal = res.data.response.total;
        this.loglistLoading = false;
      });
    },
    formatdatetime: function (row) {
      return !row.createTime || row.createTime == ""
        ? ""
        : util.formatDate.format(
            new Date(row.createTime),
            "yyyy-MM-dd hh:mm:ss"
          );
    },
  },
  mounted() {
    //查询按钮权限
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    console.info(routers);
    this.buttonList = getButtonList(this.$route.path, routers);

    // console.log(111);
    this.getBasicdatalist();
  },
};
</script>